import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HtlService, PdfLink } from "../../htl/htl.service";

@Component({
    selector: "app-htl-pdf-viewer",
    templateUrl: "./htl-pdf-viewer.component.html",
    styleUrls: ["./htl-pdf-viewer.component.scss"],
    standalone: false,
})
export class HtlPdfViewerComponent implements OnInit {
    public pdfLinks: PdfLink = { downloadLink: "" };

    private _helicopterId: number;

    constructor(
        private _route: ActivatedRoute,
        private _htlService: HtlService,
    ) {}

    ngOnInit(): void {
        this._helicopterId = this._route.snapshot.params["helicopterId"];
        this._htlService.getCurrentHelicopterHtlDocument(this._helicopterId).subscribe((result) => {
            this.pdfLinks = result;
        });
    }

    switchPage(documentId: number) {
        this._htlService.getCurrentHelicopterHtlDocument(this._helicopterId, documentId).subscribe((result) => {
            this.pdfLinks = result;
        });
    }
}
